import { z } from 'zod'
import { UTCMillisecondsSchema } from '../time'
import { MeetingIdSchema } from '../meeting'
import { AccountIdSchema, UserIdSchema } from '../ids'
import { CalendarEventIdSchema } from '../calendar'
import { AreaIdSchema } from '../area'

export const NotificationRefsSchema = z.object({
  actorUserId: UserIdSchema.optional(),
  accountId: AccountIdSchema.optional(),
  areaId: AreaIdSchema.optional(),
  eventId: CalendarEventIdSchema.optional(),
  meetingId: MeetingIdSchema.optional(),
})
export const NotificationFactsSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  oldTime: UTCMillisecondsSchema.optional(),
  newTime: UTCMillisecondsSchema.optional(),
  oldDuration: z.number().int().positive().optional(),
  newDuration: z.number().int().positive().optional(),
  outcome: z.string().optional(),
  count: z.number().int().nonnegative().optional(),
})
export type NotificationRefs = z.infer<typeof NotificationRefsSchema>
export type NotificationFacts = z.infer<typeof NotificationFactsSchema>
